import React from 'react'

export const reveleerStatusLabelType = {
  start: 'start',
  inProgress: 'in-progress',
  blocked: 'blocked',
  success: 'success',
  error: 'error'
} as const

type Props = {
  label: string
  statusLabelType: keyof typeof reveleerStatusLabelType
}

function ReveleerStatusLabel(
  props: Props
): JSX.Element {
  const {
    label,
    statusLabelType
  } = props
  return (
    <span className={ `reveleer-status-label ${reveleerStatusLabelType[statusLabelType]}` }>
      { label }
    </span>
  )
}

export default ReveleerStatusLabel
